var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 39.999,
    viewBox: "0 0 40 39.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #a8a2f4;\n      }\n\n      .cls-3 {\n        opacity: 0.1;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-5 {\n        fill: #040000;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2299",
    "data-name": "\\u77E9\\u5F62 2299",
    className: "cls-1",
    width: 11.49,
    height: 21.861
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43237",
    "data-name": "\\u7EC4 43237",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35595",
    "data-name": "\\u8DEF\\u5F84 35595",
    className: "cls-2",
    d: "M124.373,26.544a20,20,0,1,1-20-20,20,20,0,0,1,20,20",
    transform: "translate(-84.373 -6.544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43232",
    "data-name": "\\u7EC4 43232",
    className: "cls-3",
    transform: "translate(14.255 11.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43231",
    "data-name": "\\u7EC4 43231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43230",
    "data-name": "\\u7EC4 43230",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35599",
    "data-name": "\\u8DEF\\u5F84 35599",
    className: "cls-5",
    d: "M113.952,26.954a.667.667,0,0,1-.668-.668V23.758a.591.591,0,0,0-.59-.59h-3.709a.591.591,0,0,0-.59.59v2.528a.668.668,0,1,1-1.336,0V23.758a1.928,1.928,0,0,1,1.926-1.925h3.709a1.928,1.928,0,0,1,1.926,1.925v2.528a.667.667,0,0,1-.668.668",
    transform: "translate(-105.094 -21.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35600",
    "data-name": "\\u8DEF\\u5F84 35600",
    className: "cls-5",
    d: "M113.886,41.875h-8.049a1.722,1.722,0,0,1-1.721-1.72V31.8a1.722,1.722,0,0,1,1.721-1.72h8.049a1.722,1.722,0,0,1,1.72,1.72v8.352a1.722,1.722,0,0,1-1.72,1.72m-8.051-9.738-.029,7.653a.365.365,0,0,0,.363.366l7.349.028a.4.4,0,0,0,.4-.4V32.166a.364.364,0,0,0-.363-.365l-7.352-.028a.365.365,0,0,0-.366.363",
    transform: "translate(-104.116 -24.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35601",
    "data-name": "\\u8DEF\\u5F84 35601",
    className: "cls-5",
    d: "M110.983,27.768h0a.67.67,0,0,1-.67-.67V25.29a.67.67,0,1,1,1.341,0V27.1a.67.67,0,0,1-.67.67",
    transform: "translate(-106.175 -22.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35602",
    "data-name": "\\u8DEF\\u5F84 35602",
    className: "cls-5",
    d: "M113.865,27.768h0a.67.67,0,0,1-.67-.67V25.29a.67.67,0,1,1,1.341,0V27.1a.67.67,0,0,1-.67.67",
    transform: "translate(-107.132 -22.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35603",
    "data-name": "\\u8DEF\\u5F84 35603",
    className: "cls-5",
    d: "M112.288,52.117h0a.868.868,0,0,1-.868-.868V47.185h1.736v4.064a.868.868,0,0,1-.868.868",
    transform: "translate(-106.543 -30.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35604",
    "data-name": "\\u8DEF\\u5F84 35604",
    className: "cls-5",
    d: "M113.281,42.4h-4.145a.875.875,0,1,1,0-1.75h4.145a.875.875,0,1,1,0,1.75",
    transform: "translate(-105.493 -28.085)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35605",
    "data-name": "\\u8DEF\\u5F84 35605",
    className: "cls-6",
    d: "M113.952,26.388a.667.667,0,0,1-.668-.668V23.192a.591.591,0,0,0-.59-.59h-3.709a.591.591,0,0,0-.59.59V25.72a.668.668,0,1,1-1.336,0V23.192a1.928,1.928,0,0,1,1.926-1.925h3.709a1.928,1.928,0,0,1,1.926,1.925V25.72a.667.667,0,0,1-.668.668",
    transform: "translate(-90.839 -10.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35606",
    "data-name": "\\u8DEF\\u5F84 35606",
    className: "cls-6",
    d: "M113.886,41.308h-8.049a1.722,1.722,0,0,1-1.721-1.72V31.236a1.722,1.722,0,0,1,1.721-1.72h8.049a1.722,1.722,0,0,1,1.72,1.72v8.352a1.722,1.722,0,0,1-1.72,1.72m-8.051-9.738-.029,7.653a.365.365,0,0,0,.363.366l7.349.028a.4.4,0,0,0,.4-.4V31.6a.364.364,0,0,0-.363-.365l-7.352-.028a.365.365,0,0,0-.366.363",
    transform: "translate(-89.861 -12.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35607",
    "data-name": "\\u8DEF\\u5F84 35607",
    className: "cls-6",
    d: "M110.983,27.2h0a.671.671,0,0,1-.67-.67V24.723a.67.67,0,1,1,1.341,0v1.808a.671.671,0,0,1-.67.67",
    transform: "translate(-91.975 -11.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35608",
    "data-name": "\\u8DEF\\u5F84 35608",
    className: "cls-6",
    d: "M113.865,27.2h0a.671.671,0,0,1-.67-.67V24.723a.67.67,0,0,1,1.341,0v1.808a.671.671,0,0,1-.67.67",
    transform: "translate(-92.819 -11.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35609",
    "data-name": "\\u8DEF\\u5F84 35609",
    className: "cls-6",
    d: "M112.288,51.55h0a.868.868,0,0,1-.868-.868V46.618h1.736v4.064a.868.868,0,0,1-.868.868",
    transform: "translate(-92.288 -18.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35610",
    "data-name": "\\u8DEF\\u5F84 35610",
    className: "cls-6",
    d: "M113.281,41.834h-4.145a.875.875,0,1,1,0-1.75h4.145a.875.875,0,1,1,0,1.75",
    transform: "translate(-91.24 -16.358)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsb);
export default __webpack_public_path__ + "static/media/icon--usb.289f8a68f3a612ae34707386c4ede02b.svg";
export { ForwardRef as ReactComponent };